import { Scope } from "./scope";
import { WorkflowExecVariable } from "./workflow-exec-variable";
import { WorkflowFile } from "./workflow-file";
import { WorkflowForm } from "./workflow-form";
import { WorkflowStepCompletion } from "./workflow-step-completion";
import { WorkflowStepExternalOperation } from "./workflow-step-external-operation";

export interface WorkflowStep {
    id?: number;
    name: string;
    description?: string;
    due_after?: number;
    timeout_after?: number;

    script?: string;

    workflow_step_external_operations?: WorkflowStepExternalOperation[];

    target_scope_id?: number;
    target_scope?: Scope;

    target_users_variable?: WorkflowExecVariable;
    target_teams_variable?: WorkflowExecVariable;
    target_contacts_variable?: WorkflowExecVariable;

    parent_step_completion?:WorkflowStepCompletion;
    workflow_step_type_id?: StepType;
    step_completions: WorkflowStepCompletion[];

    previous_materials_visibility?: MaterialVisibility;
    is_hide_history?: boolean;
    
    completion_criteria_type?: CompletionCriteriaType;
    completion_percent?: number;
    completion_people?: number;

    default_step_completion_id?: number;
    default_step_completion?: WorkflowStepCompletion;

    visible_workflow_files?: WorkflowFile[];
    visible_workflow_forms?: WorkflowForm[];
}

export enum StepType {
    REVIEW = 1,
    APPROVAL = 2,
    CUSTOM = 3,
    AUTO = 4
}

export enum MaterialVisibility {
    MATERIAL_VISIBILITY_SHOW_ALL = 1,
    MATERIAL_VISIBILITY_HIDE_ALL = 2,
    MATERIAL_VISIBILITY_SELECT = 3
}

export enum CompletionCriteriaType {
    COMPLETION_CRITERIA_TYPE_ALL_TARGETS = 1,
    COMPLETION_CRITERIA_TYPE_PERCENT = 2,
    COMPLETION_CRITERIA_TYPE_FIRST_ONE = 3,
    COMPLETION_CRITERIA_TYPE_DECISION_REACHED = 4,
    COMPLETION_CRITERIA_TYPE_PEOPLE = 5
}